import { Button } from "@/components/ui/button";

const CALENDLY_URL = "https://calendly.com/brandon-leafrushmarketing/website?hide_gdpr_banner=1&primary_color=2f7f34";
const CALENDLY_IFRAME_URL = "https://calendly.com/brandon-leafrushmarketing/website?hide_gdpr_banner=1&primary_color=2f7f34&embed_domain=leafrushmarketing.com&embed_type=Inline";

interface CalendlyEmbedProps {
  variant?: "default" | "minimal";
}

export const CalendlyEmbed = ({ variant = "default" }: CalendlyEmbedProps) => {
  const isMinimal = variant === "minimal";

  return (
    <div className={isMinimal ? "" : "py-16 bg-accent/20"}>
      <div className="container px-4 md:px-6">
        <div className="mx-auto max-w-4xl">
          {!isMinimal && (
            <div className="text-center mb-8">
              <h3 className="text-2xl font-semibold mb-3 text-muted-foreground">Prefer to talk?</h3>
              <p className="text-base text-muted-foreground">
                Schedule a call to discuss your business
              </p>
            </div>
          )}
          
          <div className="bg-card rounded-2xl overflow-hidden shadow-sm border">
            <div style={{ width: '100%', maxWidth: '900px', margin: '0 auto' }}>
              <iframe
                src={CALENDLY_IFRAME_URL}
                width="100%"
                height="700"
                frameBorder="0"
                scrolling="no"
                title="Schedule a call with Leaf Rush Marketing"
                allow="payment"
              />
            </div>
          </div>
          
          {/* Backup link */}
          <div className="text-center mt-6">
            <p className="text-sm text-muted-foreground mb-2">
              Having trouble with the scheduler?
            </p>
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
              <Button variant="outline">Open Calendly in New Tab</Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
